/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/ThemesScreen',['pixi', 'absolute', 'lodash', 'gameconfig', 'MenuUI/Menu',
        'absolute/screenmetrics',
        'MenuUI/ControlFocusManager',
        'Solitaire/SolitaireGameMode',
        'MenuUI/SideBar',
        'MenuUI/ThemeTile',
        'MenuUI/ThemesMenu',
        'Managers/ScaleManager',
        'Managers/ScrollManager'
    ],
    function (
        PIXI, Absolute, _, GameConfig, Menu, ScreenMetrics, ControlFocusManager, SolitaireGameMode,
        SideBar, ThemeTile, ThemesMenu, ScaleManager, ScrollManager
    ) {

        var ThemesScreen = function (ui, game) {

            this.initThemesScreen(ui, game);
        };

        ThemesScreen.prototype = Object.create(Absolute.Screen.prototype);

        ThemesScreen.prototype.initThemesScreen = function (ui, game) {

            Absolute.Screen.call(this);

            this.ui = ui;
            this.game = game;


            var background = PIXI.Sprite.fromFrame('win10_MS_bg.png');
            this.background.addChild(background);

            this.controlFocusManager = new ControlFocusManager();

            this.clickHandler = this.handleGameInput.bind(this);

            window.addEventListener('click', this.clickHandler);

            this.controlFocusItems = [];
            this.themeTiles = [];
            var themeChange = function (themeId) {
                _.each(this.themeTiles, function (themeTile) {
                    themeTile.updateState(themeId === themeTile.themeId)
                });
            }.bind(this);
            _.each(GameConfig.UI.mainMenuThemes, function (tileData) {
                tileData.disableOnClick = false;
                tileData.themeChangeCallback = themeChange;
                tileData.maxWidth = Absolute.Coords.x(240);
                var themeTile = new ThemeTile(tileData, this, this.game);
                this.themeTiles.push(themeTile);
                this.controlFocusItems.push(themeTile);
            }, this);
            this.themeMenu = new ThemesMenu(_.extend({
                'tiles': this.themeTiles,
                'label': 'themes',
                'labelPosition': {
                    'y': -Absolute.Coords.y(1),
                    'x': Absolute.Coords.x(1)
                }
            }, ScaleManager.scaleParams['MenuConfigs']['MainMenuConfigs']), this.game);

            this.themeMenu.x = Absolute.Coords.x(0);
            this.currentWidth = Absolute.Coords.x(1840);
            this.scrollable = new PIXI.DisplayObjectContainer();
            this.container = new PIXI.DisplayObjectContainer();

            this.container.addChild(this.themeMenu);

            this.scrollable.addChild(this.container);
            this.addChild(this.scrollable);
            this.scrollable.width = this.currentWidth;
        };


        ThemesScreen.prototype.onShow = function () {
            if (this.themeMenu) {
                this.themeMenu.onShow();
            }
            this.game.menuBar.onShow(true, true, false, Absolute.StringManager('headings.' + this.game.config.singleGame.mode));
            this.initControls();
            if (!this.touchContainer) this.initTouchInterface();
            if (!this.sidebar) this.initSidebar();
            this.addChild(this.sidebar);
            this.scrollTo(0);
            this.addChild(this.game.menuBar);
            this.handleResize();
            ScaleManager.addElement(this, {scaleChangeSource: 'Full'});
            ScrollManager.add(this, this.doScroll, this);
        };

        ThemesScreen.prototype.onHide = function () {
            // this.container.children = [];
            this.resetControlManager();
            this.controlFocusManager.removeAllControls();
            ScaleManager.removeElement(this);
            ScrollManager.remove(this);
        };

        ThemesScreen.prototype.initControls = function () {
            // this.controlFocusManager.addControl(this.game.menuBar.controlGroup[0], false, 'MenuButton');
            // if (this.game.menuBar.fullScreenEnabled) {
            // 	this.controlFocusManager.addControl(this.game.menuBar.controlGroup[3], false, 'RightButtons');
            // }
            // for (var i = 0; i < this.themeTiles.length; i++) {
            // 	this.controlFocusManager.addControl(this.themeTiles[i], false, 'ThemeTiles');
            // }

            this.controlFocusManager.addControl(this.game.menuBar.controlGroup[0], false, 'LeftButtons');
            this.controlFocusManager.addControl(this.game.menuBar.controlGroup[1], false, 'LeftButtons');
            if (this.game.menuBar.fullScreenEnabled) {
                this.controlFocusManager.addControl(this.game.menuBar.controlGroup[3], false, 'RightButtons');
            }
            for (var i = 0; i < this.controlFocusItems.length; i++) {
                this.controlFocusManager.addControl(this.controlFocusItems[i], true, 'ThemeTiles');
            }
        };

        ThemesScreen.prototype.handleResize = function () {
            if (!this.scrollable) return;
            this.container.y = (this.game.menuBar.menuButton.y + this.game.menuBar.menuButton.height)
                * (this.container.width / ScaleManager.width)
                * (ScaleManager.height / Absolute.Coords.y(800));
            this.updatePagesPositions();
            this.scrollable.height = (this.currentWidth / this.container.width)
                * (Absolute.Coords.y(985) / ScaleManager.height)
                * (ScaleManager.width / Absolute.Coords.x(1840)) * this.currentHeight;
            this.scrollable.width = this.currentWidth;
            this.scrollableFakeHeight = this.scrollable.height + Absolute.Coords.x(210);
            if ((this.scrollable.y < 0) && ((this.scrollableFakeHeight + this.scrollable.y) < Absolute.Coords.y(1080))) {
                this.scrollable.y = Absolute.Coords.y(1080) - this.scrollableFakeHeight;
            }
            this.updateSidebar();
            this.container.x = Absolute.Coords.x(this.sidebar.visible ? -30 : 0);
        };

        ThemesScreen.prototype.updatePagesPositions = function () {
            var prevChild, scale = Math.max(this.container.width / this.currentWidth, 0.7),
                xPos = Absolute.Coords.x(50), yGap = Absolute.Coords.y(70) * scale;
            this.currentHeight = Absolute.Coords.y(50);
            this.container.children.forEach(function (c) {
                c.x = xPos;
                c.y = 0;
                this.currentHeight += c.height + (prevChild ? yGap : 0);
                prevChild = c;
            }.bind(this));
        };

        ThemesScreen.prototype.handleStatsTileClick = function (gameMode) {

        };

        ThemesScreen.prototype.handleCommand = function (command) {
            if (command === 'Back' && (!this.game.menuBar.menuOpen)) {
                this.game.navBack();
            }
            this.selectSection(command);
            if (!this.controlFocusManager.currentFocusGroup) return;
            switch (command) {
                case 'Right': {
                    this.controlFocusManager.focusNextControl(1);
                    break;
                }
                case 'Left': {
                    this.controlFocusManager.focusNextControl(-1);
                    break;
                }
                case 'Up': {
                    this.controlFocusManager.focusNextControl(-1);
                    break;
                }
                case 'Down': {
                    this.controlFocusManager.focusNextControl(1);
                    break;
                }
                case 'Activate':
                    this.controlFocusManager.activateCurrentControl();
                    break;
                case 'Unfocus':
                    this.controlFocusManager.unfocusCurrentControl();
                    break;
            }
        };

        ThemesScreen.prototype.selectSection = function (command) {
            if (command === 'Tab' || command === 'ShiftTab') {
                this.controlFocusManager.focusCurrentControl();
                if (command === 'Tab') {
                    if (
                        this.controlFocusManager.currentFocusGroup ===
                        this.controlFocusManager.getLastControl().focusGroup
                    ) {
                        this.controlFocusManager.setFocusGroup('LeftButtons');
                    } else {
                        this.controlFocusManager.nextFocusGroup();
                    }
                } else if (command === 'ShiftTab') {
                    if (
                        this.controlFocusManager.currentFocusGroup ===
                        this.controlFocusManager.getFirstControl().focusGroup
                    ) {
                        this.controlFocusManager.setFocusGroup(this.controlFocusManager.getLastControl().focusGroup);
                    } else {
                        this.controlFocusManager.prevFocusGroup();
                    }
                }
            }
        };

        ThemesScreen.prototype.handleGameInput = function () {
            this.resetControlManager();
        };

        ThemesScreen.prototype.resetControlManager = function () {
            this.controlFocusManager.unfocusCurrentControl();
        };

        ThemesScreen.prototype.initSidebar = function () {
            this.sidebar = new SideBar({
                availableHeight: 200, partialHeight: 100,
                onScrollUpdate: function (p) {
                }.bind(this)
            });
            this.addChild(this.sidebar);
            this.sidebar.position.set(Absolute.Coords.x(1900), Absolute.Coords.y(67));
        };

        ThemesScreen.prototype.updateSidebar = function () {
            if (!this.sidebar || !this.scrollable) return;
            var height = Absolute.Coords.y(66),
                headerHeight = ((height / ScaleManager.scaleFactorY));
            var screenScaleX = ScaleManager.width / Absolute.Coords.x(1920),
                screenScaleY = ScaleManager.height / Absolute.Coords.y(1080);
            this.sidebar.scale.set(1, 1);
            this.sidebar.width = this.sidebar.width / screenScaleX;
            this.sidebar.height = this.sidebar.height / screenScaleY;
            this.sidebar.y = headerHeight;
            this.sidebar.x = Absolute.Coords.x(1900) - (this.sidebar.width - (this.sidebar.width * screenScaleX));
            var availableHeight, partialHeight, posY;
            availableHeight = this.scrollableFakeHeight;
            partialHeight = Absolute.Coords.x(1080);
            posY = availableHeight - Absolute.Coords.y(1080);
            this.sidebar.resetDimensions(availableHeight, partialHeight, function (p) {
                var y = -Math.abs(posY) * p / 100;
                this.scrollable.y = y;
                if (this.scrollable.y > 0) this.scrollable.y = 0;
                if (Math.abs(this.scrollable.y) > posY) {
                    this.scrollable.y = -posY;
                }
            }.bind(this), (ScaleManager.height - 65));
            this.sidebar.visible = false;
            this.sidebar.visible = (partialHeight < availableHeight);
            if (this.sidebar.visible) {
                this.sidebar.updateHandleByPercent(100 * Math.abs(this.scrollable.y) / Math.abs(posY));
            } else {
                this.scrollable.y = 0;
            }
        };

        ThemesScreen.prototype.initTouchInterface = function () {
            // Dragging and panning
            this.lastDeltaY = 0;
            this.startY = 0;
            var hitArea = new PIXI.Rectangle(0, 0, Absolute.Coords.x(1920), Absolute.Coords.y(1080));
            this.touchContainer = new PIXI.DisplayObjectContainer();
            this.touchContainer.interactive = true;
            this.touchContainer.hitArea = hitArea;
            this.touchContainer.addChild(this.scrollable);
            this.touchContainer.mousedown = this.touchContainer.touchstart = this.handleDragStart.bind(this);
            this.touchContainer.mousemove = this.touchContainer.touchmove = this.handleDrag.bind(this);
            this.touchContainer.mouseupoutside = this.touchContainer.mouseup = this.touchContainer.touchend = this.touchContainer.touchendoutside = this.handleDragEnd.bind(this);
            this.addChild(this.touchContainer);

        };

        ThemesScreen.prototype.handleDragStart = function (data) {
            this.dragging = true;
            this.lastDeltaY = 0;
            this.startY = data.getLocalPosition(this.parent).y;
            this.enableButtons(false);
        };

        ThemesScreen.prototype.handleDrag = function (data) {

            if (!this.dragging) {
                return;
            }

            var pos = data.getLocalPosition(this.parent),
                delta = pos.y - this.startY;

            this.scrollTo(this.scrollable.y + ((delta - this.lastDeltaY) * ScreenMetrics.devicePixelRatio));

            this.lastDeltaY = delta;
        };

        ThemesScreen.prototype.handleDragEnd = function (data) {

            if (!this.dragging) {
                return;
            }
            this.dragging = false;
        };

        ThemesScreen.prototype.enableButtons = function (enable) {

            var i, l;

            for (i = 0, l = this.scrollable.children.length; i < l; i++) {
                this.scrollable.children[i].interactive = enable;
            }

        };

        ThemesScreen.prototype.scrollTo = function (y) {
            if (!this.scrollable) return;
            if (this.scrollableFakeHeight <= Absolute.Coords.y(1080)) {
                this.scrollable.y = 0;
                return;
            }
            this.scrollable.y = y;
            if (this.scrollable.y > 0) this.scrollable.y = 0;
            var posY = this.scrollableFakeHeight - Absolute.Coords.y(1080);
            if (Math.abs(this.scrollable.y) > posY) {
                this.scrollable.y = -posY;
            }
            if (this.sidebar) this.sidebar.updateHandleByPercent(100 * Math.abs(this.scrollable.y) / Math.abs(posY));
        };


        ThemesScreen.prototype.doScroll = function (e) {
            if (this.scrollableFakeHeight < Absolute.Coords.y(1080)) return;
            var deltaY = 0;
            if (!e) e = window.event;
            if (e.wheelDelta) {
                deltaY = e.wheelDelta / 15;
            } else if (e.detail) {
                deltaY = -e.detail / 3;
            }
            this.scrollTo(this.scrollable.y + (deltaY * 100));
        };

        return ThemesScreen;

    });



